export default class BookingNotes {
  residentNote?: string = undefined;
  staffNote?: string = undefined;
  constructor(residentNote?: string, staffNote?: string) {
    this.residentNote = residentNote;
    this.staffNote = staffNote;
  }
}
